import React from "react";
import "./AppCarousel.scss";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import slideOne from "../assets/slide/1.jpg";
import slideTwo from "../assets/slide/2.jpg";
import slideThree from "../assets/slide/3.jpg";
import slideFour from "../assets/slide/4.jpg";

const carouselImages = [slideOne, slideTwo, slideThree, slideFour];

function AppCarousel() {
  return (
    <Carousel
      className="home__carousel"
      showArrows={false}
      showStatus={false}
      infiniteLoop={true}
      autoPlay={true}
      showThumbs={false}
      interval={5000}
      transitionTime={200}
    >
      {carouselImages.map((carouselImage,i) => (
        <div key={i}>
          <img src={carouselImage} alt="carousel" />
        </div>
      ))}
    </Carousel>
  );
}

export default AppCarousel;
